import { render, staticRenderFns } from "./DraftRecieve.vue?vue&type=template&id=621976d2"
import script from "./DraftRecieve.vue?vue&type=script&lang=js"
export * from "./DraftRecieve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports